module.exports = __webpack_public_path__ + "img/2.2c3c553d.png";